<template>
  <v-overlay
    :value="unavailable"
    :opacity="1"
    color="#F5F5FC"
    z-index="2000"
  >
    <div class="maintenance text-center">
      <v-img
        class="mx-auto mb-6"
        src="/img/plas-logo.png"
        contain
        :height="96"
      />
      <v-icon size="64" color="grey darken-1">{{ icon }}</v-icon>
      <h2 class="headline grey--text text--darken-3 mt-4 mb-2">{{ $t(title) }}</h2>
      <p class="body-1 grey--text text--darken-1 mb-6">{{ $t(message) }}</p>
      <v-btn
        color="primary"
        :loading="checking"
        @click="check"
      >
        {{ $t('MAINTENANCE_RETRY') }}
      </v-btn>
      <div class="caption grey--text mt-4">{{ $t('MAINTENANCE_AUTO_RETRY') }}</div>
    </div>
  </v-overlay>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  const CONTENT = {
    maintenance: {
      icon: 'build',
      title: 'MAINTENANCE_TITLE',
      message: 'MAINTENANCE_MESSAGE',
    },
    offline: {
      icon: 'wifi_off',
      title: 'MAINTENANCE_OFFLINE_TITLE',
      message: 'MAINTENANCE_OFFLINE_MESSAGE',
    },
    unreachable: {
      icon: 'cloud_off',
      title: 'MAINTENANCE_UNREACHABLE_TITLE',
      message: 'MAINTENANCE_UNREACHABLE_MESSAGE',
    },
  };

  export default {
    name: 'TheMaintenance',
    computed: {
      ...mapState('system', ['unavailable', 'reason', 'checking']),
      content() {
        return CONTENT[this.reason] || CONTENT.unreachable;
      },
      icon() {
        return this.content.icon;
      },
      title() {
        return this.content.title;
      },
      message() {
        return this.content.message;
      },
    },
    methods: {
      ...mapActions('system', ['check']),
    },
  };
</script>

<style scoped>
  .maintenance {
    max-width: 480px;
    padding: 24px;
  }
</style>
